import React from 'react'

const TextArea = ({ label, error,...props },ref) => {
    return (
      <label className={`div-textarea ${error ? "error" :""} ${props.readonly ? "readonly" : ""}`}>
        {label && (
          <div className="header">
            <span className="title">{label}</span>
          </div>
        )}
        <textarea ref={ref} disabled={props.readonly} {...props}></textarea>
        <span className="text-error">{error}</span>
      </label>
    );
}

export default React.forwardRef(TextArea);